import { http } from "../../../shared/api/http"

export type ModulePayload = {
  course_id: string
  title: string
  description?: string
  order_number: number
  duration_minutes: number
}

export type ModuleUpdatePayload = {
  title?: string
  description?: string
  order_number?: number
  duration_minutes?: number
}

export type ModuleListItem = {
  id: string
  course_id: string
  title: string
  description?: string
  order_number: number
  lessons_count: number
  duration_minutes: number
  has_free_lessons: boolean
}

export type ModuleListResponse = {
  items: ModuleListItem[]
}

export const listModulesApi = (courseId: string) =>
  http.get<ModuleListResponse>(
    `/api/courses/${courseId}/modules`
  )

export const createModuleApi = (payload: ModulePayload) =>
  http.post<ModuleListItem>(
    `/api/admin/modules/create`,
    payload
  )

export const updateModuleApi = (
  moduleId: string,
  payload: ModuleUpdatePayload
) =>
  http.patch<ModuleListItem>(
    `/api/admin/modules/${moduleId}/update`,
    payload
  )

export const deleteModuleApi = (moduleId: string) =>
  http.delete<void>(
    `/api/admin/modules/${moduleId}/delete`
  )

/** Mentor content editing — narrower field set (no create/delete, no reordering across courses). */
export const updateMentorModuleApi = (
  moduleId: string,
  payload: ModuleUpdatePayload
) =>
  http.patch<ModuleListItem>(
    `/api/mentor/modules/${moduleId}`,
    payload
  )

export type ModuleDetail = {
  id: string
  course_id: string
  title: string
  description?: string
  order_number: number
  duration_minutes?: number
  lessons_count?: number
}

export const getModuleApi = (
  courseId: string,
  moduleId: string
) =>
  http.get<ModuleDetail>(
    `/api/courses/${courseId}/modules/${moduleId}`
  )